import { z } from 'zod'

export const AGENTMCP_HTTP_CONTRACT_VERSION = '1.0.0' as const
const jsonObject = z.record(z.unknown())

export const agentmcpAuthRequestOtpResponseSchema = jsonObject
export const agentmcpAuthVerifyOtpResponseSchema = jsonObject
export const agentmcpAuthDesktopVerifyOtpResponseSchema = jsonObject
export const agentmcpSessionRefreshResponseSchema = jsonObject
export const agentmcpSessionListResponseSchema = jsonObject
export const agentmcpSessionRevokeResponseSchema = jsonObject
export const agentmcpHealthResponseSchema = jsonObject
export const agentmcpChatStartResponseSchema = jsonObject
export const agentmcpChatTurnResponseSchema = jsonObject
export const agentmcpChatReadResponseSchema = jsonObject
export const agentmcpCreditsLedgerResponseSchema = jsonObject
export const agentmcpSubmitQuoteResponseSchema = jsonObject
export const agentmcpSubmitConfirmResponseSchema = jsonObject
export const agentmcpCatalogSyncResponseSchema = jsonObject
export const agentmcpHttpRecipeRunResponseSchema = jsonObject
export const agentmcpSttSessionResponseSchema = jsonObject
export const agentmcpSttCommitResponseSchema = jsonObject
export const agentmcpSubmissionResultResponseSchema = jsonObject

export type AgentmcpAuthRequestOtpResponse = z.infer<typeof agentmcpAuthRequestOtpResponseSchema>
export type AgentmcpAuthVerifyOtpResponse = z.infer<typeof agentmcpAuthVerifyOtpResponseSchema>
export type AgentmcpAuthDesktopVerifyOtpResponse = z.infer<typeof agentmcpAuthDesktopVerifyOtpResponseSchema>
export type AgentmcpSessionRefreshResponse = z.infer<typeof agentmcpSessionRefreshResponseSchema>
export type AgentmcpSessionListResponse = z.infer<typeof agentmcpSessionListResponseSchema>
export type AgentmcpSessionRevokeResponse = z.infer<typeof agentmcpSessionRevokeResponseSchema>
export type AgentmcpHealthResponse = z.infer<typeof agentmcpHealthResponseSchema>
export type AgentmcpChatStartResponse = z.infer<typeof agentmcpChatStartResponseSchema>
export type AgentmcpChatTurnResponse = z.infer<typeof agentmcpChatTurnResponseSchema>
export type AgentmcpChatReadResponse = z.infer<typeof agentmcpChatReadResponseSchema>
export type AgentmcpCreditsLedgerResponse = z.infer<typeof agentmcpCreditsLedgerResponseSchema>
export type AgentmcpSubmitQuoteResponse = z.infer<typeof agentmcpSubmitQuoteResponseSchema>
export type AgentmcpSubmitConfirmResponse = z.infer<typeof agentmcpSubmitConfirmResponseSchema>
export type AgentmcpCatalogSyncResponse = z.infer<typeof agentmcpCatalogSyncResponseSchema>
export type AgentmcpHttpRecipeRunResponse = z.infer<typeof agentmcpHttpRecipeRunResponseSchema>
export type AgentmcpSttSessionResponse = z.infer<typeof agentmcpSttSessionResponseSchema>
export type AgentmcpSttCommitResponse = z.infer<typeof agentmcpSttCommitResponseSchema>
export type AgentmcpSubmissionResultResponse = z.infer<typeof agentmcpSubmissionResultResponseSchema>
